import { SuspensedView } from './components';
import { PublicUploadDocumentsPage } from 'components/publicUploadDocumentsPage/publicUploadDocumentsPage';
import { PublicUploadEmployeePhotoPage } from 'components/publicUploadEmployeePhotoPage/publicUploadEmployeePhotoPage';
import { PersonalDataPage } from 'features/employees/components/emploee-personal-data-standalone/personal-data-page';
import { NotificationMessagesWrapper } from 'features/notifications';
import { VhcCreatePageWrapper } from 'features/vhc/pages/create/vhc-create-page-wrapper';
import { VhcRecordPageWrapper } from 'features/vhc/pages/record/vhc-record-page.wrapper';
import { PageLink, PageTitle } from 'layouts/core/page-data';
import { MasterLayout } from 'layouts/master';
import MainApp from 'main-app';
import { Navigate, Route, Routes } from 'react-router-dom';

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Admin Panel',
    path: '/dashboard',
    isSeparator: false,
    isActive: false
  },

  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
];

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route
        path="/employees/uploadPhoto/*"
        element={
          <SuspensedView>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Upload Photo</PageTitle>
            <PublicUploadEmployeePhotoPage />
          </SuspensedView>
        }
      />
      <Route
        path="/employees/documents/upload/*"
        element={
          <SuspensedView>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Upload Required documents</PageTitle>
            <PublicUploadDocumentsPage />
          </SuspensedView>
        }
      />
      <Route
        path="/employees/editPersonalDetails/*"
        element={
          <SuspensedView>
            <PageTitle breadcrumbs={usersBreadcrumbs}>Edit Personal Details</PageTitle>
            <PersonalDataPage />
          </SuspensedView>
        }
      />

      <Route path="/notifications/*" element={<NotificationMessagesWrapper />} />
      <Route path="/vhc/:id" element={<VhcRecordPageWrapper />} />
      <Route path="/vhc/create" element={<VhcCreatePageWrapper />} />
      <Route path="*" element={<Navigate to="/error/404" />} />
    </Routes>
  );
};
